<template>
  <div class="emptydivbox">
    <i class="iconfont icon-Null-data"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.emptydivbox {
  height: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  > i {
    font-size: 40px;
    color: #ccc;
    line-height: 1em;
  }
  > div {
    font-size: 14px;
    color: #ccc;
    margin-top: 5px;
    letter-spacing: 1px;
  }
}
</style>
